import React, { useEffect, useState } from "react";
import theme from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Card from "../../components/common/Card";
import BarChart from "../../components/ReportComponent/BarChart";
import PieChart from "../../components/common/PieChart/PieChart";
import GenericTableComponent from "../../components/common/Table.jsx";
import { convertToLocalCurrency } from '../../utils/currency';

import { getTopBoard } from "../../redux/slices/overviewSlice.jsx";
import { getCampaignByYear } from "../../redux/slices/reportSlice.jsx";

import Swal from "sweetalert2";

import {
  Container,
  CardWrapper,
  ChartWrapper,
  TableWrapper,
} from "./ReportsStyles.jsx";

const columns = [
  { id: "month", label: "Month" },
  { id: "totalClicks", label: "Clicks" },
  { id: "totalConversions", label: "Conversions" },
  { id: "conversionRate", label: "Conversion Rate" },
  { id: "amountSpent", label: "Amount Spent" },
];

const Reports = () => {
  const dispatch = useDispatch();
  const { topboard } = useSelector((state) => state.overview);
  const { campaignByYear } = useSelector((state) => state.report);

 const [exportData] = useState(true)
  const [exportLoading, setExportLoading] = useState(false);


  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const years = [];
  for (let i = currentYear; i >= 2020; i--) {
    years.push(i);
  }


  useEffect(() => {
    dispatch(getTopBoard({}));
    dispatch(getCampaignByYear({ year }));
  }, [dispatch, year]);

  const handleYear = (event) => {
    const selectedYear = Number(event.target.value);
    setYear(selectedYear);
  };

  const handleExport = async () => {
    try {
      setExportLoading(true);
      
      const response = await 
      dispatch(getCampaignByYear({year, exportData})).unwrap();

      // Get the file URL from the response
      if (response.data.file) {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = response.data.file;
        link.setAttribute('download', `Campaign-report.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        Swal.fire({
          title: 'Export Status',
          text: response.data.message || 'No file available for download',
          icon: 'info',
          confirmButtonColor: theme.color.brand
        });
      }
    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        title: 'Export Failed',
        text: error.message || 'Failed to export publisher details',
        icon: 'error',
        confirmButtonColor: theme.color.brand
      });
    } finally {
      setExportLoading(false);
    }
  };
  

  return (
    <Container>
      <div className="heading">
        <div className="texts">
          <h1>Reports</h1>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" to="/create-campaign">
            + Create Campaign
          </Link>
        </div>
      </div>
      <CardWrapper>
        <Card
          text={"Total no of Campaigns"}
          totalCount={topboard?.totalCampaigns}
        />
        <Card
          text={"Approved Campaigns"}
          totalCount={topboard?.approvedCampaigns}
        />
        <Card text={"Money spent"} totalCount={convertToLocalCurrency(`${topboard?.moneySpent}`)} />
      </CardWrapper>
      <h3>Campaign Analytics</h3>
      <ChartWrapper>
        <div className="left">
          <BarChart />
        </div>

        <div className="right">
          <PieChart />
        </div>
      </ChartWrapper>

      <TableWrapper>
        <div className="header">
          <div className="texts">
            <h3>Monthly Report</h3>
            <p>Keep track of your Ads with DigiClick</p>
          </div>

          <div className="link-buttons">
            <select className="see-more2" value={year} onChange={handleYear}>
              <option value="" disabled>Select Year</option>
              {years.map((yearOption) => (
                <option key={yearOption} value={yearOption}>
                  {yearOption}
                </option>
              ))}
            </select>

            <button 
                className="export-button"
                onClick={handleExport}
                disabled={exportLoading}
              >
                {exportLoading ? 'Exporting...' : 'Export CSV'}
            </button>
          </div>
        </div>
        <div style={{ padding: "0" }}>
          <GenericTableComponent
            columns={columns}
            data={campaignByYear}
            reportView
            viewLink="/view-report"
            // showExport={true}
            // onExport={handleExport}
            // exportLoading={exportLoading}
            // filterSearch={true}
            // hideSearch
          />
        </div>
      </TableWrapper>
    </Container>
  );
};

export default Reports;
